// Имя бота для дип-линков (t.me/<bot>?startapp=replay_<id>).
let botUsername: string | null = null;

export function setBotUsername(u: string | null) {
  botUsername = u;
}

// Ссылка, которая откроет конкретный реплей в Mini App у любого, кто перейдёт.
export function replayLink(betId: number): string {
  return botUsername ? `https://t.me/${botUsername}?startapp=replay_${betId}` : '';
}
